import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {fetchAttendence} from '../../redux/action/studentAction'
import Footer from '../../Components/Footer';
import '../../Style/StuResult.css';
import HomeHelper from '../../Components/HomeHelper'
import { useHistory } from 'react-router-dom'
import Loading from '../../Components/Loading';


const Home = () => {
    const store = useSelector(store => store)
    const history = useHistory()
    const dispatch = useDispatch()


    useEffect(() => {
      dispatch(fetchAttendence())  
    },[])
    const isattendenceAvailable = store.student.attendence && store.student.attendence.length > 0;

    return (
        <div>
            {store.student.isAuthenticated ? <>
                <HomeHelper />
                <div className="container-fluid main"style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}>
                <div className='px-4 py-1 bg-light d-flex align-items-center justify-content-between'>
                            <h3 className='d-flex align-items-center justify-content-between'> <img src="/logo192.png" width={'40px'} alt="" /> Attendence</h3>
                            <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                        </div>
                    <div className="row mt-3">
                        <div className="col-md-10 m-auto">
                        <div className='resultT p-2'>
                            <h2 className='text-center'>Student Attendence</h2><br />
                            <div className='d-flex align-items-center justify-content-around '> <h5>Department :{store.student.student.student.department} </h5>
                            <h5>Year :{store.student.student.student.year} </h5>
                            <h5>Semester:{store.student.student.student.semester} </h5>
                            <h5>Section:{store.student.student.student.section} </h5></div>
                        </div>
                        <table className="table resultT table-responsive table-striped table-bordered">
                                <thead>
                                    <tr className="table resultTcol text-light">
                                        <th scope="col " width="10%">S.No</th>
                                        <th scope="col" width="15%">Subject Code</th>
                                        <th scope="col" width="25%">Subject Name</th>
                                        <th scope="col" width="10%">Maximum Hours</th>
                                        <th scope="col" width="10%">Present Hours</th>
                                        <th scope="col" width="10%">Absent Hours</th>
                                        <th scope="col" width="10%">Total Hours</th>
                                        <th scope="col" width="10%">Attendence</th>
                                    </tr>
                                </thead>
                                {isattendenceAvailable ? (
                                <tbody>
                                    {
                                        store.student.attendence.map((res, index) =>
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{res.subjectCode}</td>
                                                <td>{res.subjectName}</td>
                                                <td>{res.maxHours}</td>
                                                <td>{res.lectureAttended}</td>
                                                <td>{res.absentHours}</td>
                                                <td>{res.totalLecturesByFaculty}</td>
                                                <td>{res.attendence}%</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                                ) : (
                                    <Loading />
                                      
                                  )}
                            </table>
                        </div>
                    </div>
                </div>
            </> : (history.push('/'))}
           
            <Footer />
        </div>

    )
}

export default Home
